<template>
    <div>
    <Header></Header>
    <Login></Login>
    <div class="productIntro-list">
        <div class="productIntro-list-item" v-for="(item,index) in productIntroList" :key="index">
            <div class="product-item-info" :style="{background:'url('+item.productIntroItemBg+') 0% 0% / 100% 100%'}">
                <div class="productIntro-item-info-wrapper">
                  <div>
                    <div class="productIntro-item-title">{{item.productIntroItemTitle}}</div>
                    <div class="productIntro-item-title-content">RES房地产数据分析系统根植于澜思内部的案例数据库，该数据库记录了2005年以来上海的土地、新房及二 手房成交案例数据，方式不局限于自动化的爬虫工具、全量化的数据清洗、专业化的人工复核，在470多万条案例数据的基础上，<span>我们建立了量化统计、竞对分析、个案分析等模块</span>，力求最大程度地复现上海市场的房屋交易场景。</div>
                  </div>
                  <div class="productIntro-item-img"><img src="../assets/images/productIntro/res-bg@2x.png" /></div>
                </div>
            </div>
            <div class="product-advantage">
                <div class="product-advantage-title">产品优势</div>
                <div class="product-advantage-enTitle">Product Advantages</div> 
                <div class="product-advantage-list">
                    <div class="product-advantage-list-item" v-for="(v,i) in item.productAdvantageList" :key="i">
                        <div class="product-advantage-list-item-wrapper">
                            <div class="product-advantage-img">
                                <img :src="v.productAdvantageIcon" alt="">
                            </div>
                            <div class="text">{{v.productAdvantageTitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-function">
                <div class="product-function-title">产品主要功能</div>
                <div class="product-function-enTitle">The Main Function of The Product</div>
                <div class="product-function-list">
                    <div class="product-function-item" v-for="(vv,ii) in item.productFunctionList" :key="ii">
                        <div class="product-function-item-left">
                            <img :src="vv.productFunctionImgUrl" alt="">
                        </div>
                        <div class="product-function-item-right">
                            <div class="product-function-item-title">{{vv.productFunctionText}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customer-case">
                <div class="customer-case-title">客户案例</div>
                <div class="customer-case-enTitle">Customer Case</div>
                <div class="customer-case-content" :style="{background:'url('+item.customerCaseBgUrl+') 0% 0% / 100% 100%'}">
                   <div class="customer-case-content-wrapper">
                      <div class="customer-case-content-title">{{item.customerCaseContentTitle}}</div>
                      <div class="customer-case-content-text">{{item.customerCaseContentText}}</div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "productIntro",
  components: {
    Header,
    Footer,
    Login
  },
  data() {
    return {
      productIntroList: [
        {
          id: 1,
          productIntroItemBg: require("../assets/images/productIntro/banner-bg@2x.png"),
          productIntroItemTitle: "RES房地产数据分析系统",
          productIntroItemContent:
            "RES房地产数据分析系统根植于澜思内部的案例数据库，该数据库记录了2005年以来上海的土地、新房及二 手房成交案例数据，方式不局限于自动化的爬虫工具、全量化的数据清洗、专业化的人工复核，在470多万条案例数据的基础上，",
          productAdvantageList: [
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_res0.png"),
              productAdvantageTitle: "自动化的爬虫工具"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_res2.png"),
              productAdvantageTitle: "全量化的数据清洗"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_res1.png"),
              productAdvantageTitle: "专业化的人工复核案例数据"
            }
          ],
          productFunctionList: [
            {
              productFunctionImgUrl: require("../assets/images/productIntro/主要功能-res@2x.png"),
              productFunctionText:
                "宏观市场、个案查询、市场排行、数据分析、楼盘宝库等"
            }
          ],
          customerCaseBgUrl: require("../assets/images/productIntro/客户案例-res-bg@2x.png"),
          customerCaseContentTitle: "链家地产",
          customerCaseContentText:
            "不仅通过RES系统了解房地产交易市场，同时确定主营、视野楼盘配合企业门店布局，以及相关楼盘的成交监测，从而提升企业管理运营效率"
        }
      ]
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
@import "../assets/css/productIntro.less";

.text {
  width: 192px;
  margin-left: 32px;
  height: 64px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #272727;
  line-height: 64px;
}

.product-advantage-list-item:last-child .text {
  line-height: 34px;
}
</style>


